import { CarListingData } from '@/types';
import { CarStatus } from '@/types';
import { MakeModel } from '@/types/filter.types';
import { AvailableCheckClient } from '@/utils/clientUtil';

export const priceDefaultMin = 150000;
export const priceDefaultMax = 3500000;

type TCompareTypes =
    | 'eq'
    | 'neq'
    | 'gte'
    | 'gt'
    | 'lt'
    | 'lte'
    | 'in'
    | 'nin'
    | 'range'
    | 'function';
export type comparableTypes =
    | string
    | string[]
    | number
    | number[]
    | boolean
    | boolean[];
// eslint-disable-next-line no-unused-vars
type TCompareFunction<T> = (item: T, val: comparableTypes) => boolean;
export interface TFilterTerm<T> {
    isEnabled: boolean;
    compareType: TCompareTypes;
    keyName: keyof T;
    keyValue: comparableTypes;
    fn?: TCompareFunction<T>;
}
export default class FilterableContent<dT extends { id: string }> {
    filters: TFilterTerm<dT>[] = [];
    data: dT[] = [];
    filteredData: dT[] = [];
    filterIndexes: Record<string, boolean> = {};
    public SetData(data: dT[]) {
        this.data = data;
        this.filteredData = data;
        this.filterIndexes = {};
        return this;
    }
    public SetFilters(filters: TFilterTerm<dT>[]) {
        // console.log('filters are >>>>> ', filters);
        this.filters = filters;
        const requiredIndexes = [];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let q = 0; q < filters.length; q++) {
            if (filters[q].compareType === 'in') {
                requiredIndexes.push(filters[q].keyName);
            }
        }
        //building indexes
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let w = 0; w < this.data.length; w++) {
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let e = 0; e < requiredIndexes.length; e++) {
                const indexName: string =
                    String(this.data[w][requiredIndexes[e]]).toLowerCase() +
                    this.data[w].id;
                this.filterIndexes[indexName] = true;
            }
        }

        return this;
    }
    public ResetFilters() {
        this.filterIndexes = {};
        this.filters = [];
        this.filteredData = this.data;
        return this;
    }
    private compareEq<CT>(item: dT, k: keyof dT, v: CT) {
        // console.log('this is the eq funcition ', k, v);
        // console.log('actual data is ', item[k]);
        // console.log('should return ', item[k] === v);
        if (typeof item[k] == 'string') {
            return (item[k] as string).toLowerCase() === v;
        } else {
            return item[k] === v;
        }
    }
    private compareNeq<CT>(item: dT, k: keyof dT, v: CT) {
        return item[k] !== v;
    }

    private compareIn(item: dT, k: keyof dT, v: unknown[]) {
        let found = false;
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let q = 0; q < v.length; q++) {
            const indexName = String(v[q] + item.id);
            // console.log('indexName', indexName);
            found = !!this.filterIndexes[indexName];
            if (found) {
                break;
            }
        }
        return found;
        /*
    let searchableItem = (item[k] as string).toLowerCase();
    let found = false;
    for (let q = 0; q < v.length; q++) {
      if (v[q] === searchableItem) {
        found = true;
        break;
      }
    }
    return found;*/
        // let val = v.includes((item[k] as string).toLowerCase());
        // return val;
    }
    private compareNin(item: dT, k: keyof dT, v: unknown[]) {
        return !v.includes((item[k] as string).toLowerCase());
    }

    // | 'lt' | 'lte'
    private compareGte(item: dT, k: keyof dT, v: number) {
        return Number(item[k]) >= v;
    }
    private compareGt(item: dT, k: keyof dT, v: number) {
        return Number(item[k]) > v;
    }
    private compareLt(item: dT, k: keyof dT, v: number) {
        return Number(item[k]) < v;
    }
    private compareLte(item: dT, k: keyof dT, v: number) {
        return Number(item[k]) <= v;
    }
    private compareRange(item: dT, k: keyof dT, v: number[]) {
        return Number(item[k]) >= v[0] && Number(item[k]) <= v[1];
    }
    private compareFunction(
        item: dT,
        k: keyof dT,
        v: comparableTypes,
        fn: TCompareFunction<dT>
    ) {
        return fn(item, v);
    }

    private compare(
        item: dT,
        compareType: TCompareTypes,
        keyName: keyof dT,
        value: comparableTypes,
        fn?: TCompareFunction<dT>
    ) {
        switch (compareType) {
            case 'eq':
                return this.compareEq(item, keyName, value);
            case 'neq':
                return this.compareNeq(item, keyName, value);
            case 'in':
                return this.compareIn(item, keyName, value as unknown[]);
            case 'nin':
                return this.compareNin(item, keyName, value as unknown[]);
            case 'gte':
                return this.compareGte(item, keyName, value as number);
            case 'gt':
                return this.compareGt(item, keyName, value as number);
            case 'lte':
                return this.compareLte(item, keyName, value as number);
            case 'lt':
                return this.compareLt(item, keyName, value as number);
            case 'range':
                return this.compareRange(item, keyName, value as number[]);
            case 'function':
                if (fn && typeof fn === 'function') {
                    return this.compareFunction(item, keyName, value, fn);
                }
                break;
        }
    }
    private applyFilter(filter: TFilterTerm<dT>) {
        this.filteredData = this.filteredData.filter(item => {
            return this.compare(
                item,
                filter.compareType,
                filter.keyName,
                filter.keyValue,
                filter.fn
            );
        });
    }
    public ApplyFilters() {
        // console.log('initial size', this.filteredData.length);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let q = 0; q < this.filters.length; q++) {
            const filter = this.filters[q];
            // console.log('applying filter ', filter);
            if (filter.isEnabled) {
                // console.time('filter Phase');
                this.applyFilter(filter);
                // console.timeEnd('filter Phase');
                // console.log('now size', this.filteredData.length);
            }
        }
        return this;
    }
}

export const buildFilters = ({
    make,
    model,
    queryMake,
    queryModel,
    queryTransmission,
    queryKilometers,
    queryYear,
    queryPrice,
    queryStatus,
    queryBodyStyle,
    client = false,
}: {
    make?: string;
    model?: string;
    queryMake?: string;
    queryModel?: string;
    queryTransmission?: string;
    queryKilometers?: string;
    queryYear?: string;
    queryPrice?: string;
    queryStatus?: string;
    queryBodyStyle?: string;
    comboList?: MakeModel;
    client?: boolean;
}): TFilterTerm<CarListingData>[] => {
    const filters: TFilterTerm<CarListingData>[] = [];
    //single make
    if (make) {
        filters.push({
            isEnabled: true,
            keyName: 'make',
            keyValue: [make],
            compareType: 'in',
        });
    }
    //single model
    if (model) {
        filters.push({
            isEnabled: true,
            keyName: 'model',
            keyValue: [model],
            compareType: 'in',
        });
    }
    if (queryTransmission) {
        const transmissions = queryTransmission.split(',');

        filters.push({
            isEnabled: true,
            keyName: 'transmission',
            keyValue: transmissions,
            compareType: 'in',
        });
    }

    if (queryYear) {
        const yearFilter = queryYear.split(',');
        if (yearFilter.length === 1) {
            filters.push({
                isEnabled: true,
                keyName: 'year',
                keyValue: Number(yearFilter[0]),
                compareType: 'gte',
            });
        }
        if (yearFilter.length === 2) {
            filters.push({
                isEnabled: true,
                keyName: 'year',
                keyValue: [Number(yearFilter[0]), Number(yearFilter[1])],
                compareType: 'range',
            });
        }
    }

    if (queryKilometers) {
        filters.push({
            isEnabled: true,
            keyName: 'kilometers',
            keyValue: Number(queryKilometers),
            compareType: 'lte',
        });
    }

    if (queryPrice) {
        const pricesFilter = queryPrice.split(',');
        let min =priceDefaultMin;
        let max = priceDefaultMax;
        if (Number(pricesFilter[0]) > min) {
            min = Math.max(Number(pricesFilter[0]),priceDefaultMin);
        }
        if (Number(pricesFilter[1]) < priceDefaultMax) {
            max = Math.min(Number(pricesFilter[1]),priceDefaultMax);
        }
        if (min != priceDefaultMin || max !== priceDefaultMax) {
            filters.push({
                isEnabled: true,
                keyName: 'sylndrSellingPrice',
                keyValue: [min, max],
                compareType: 'range',
            });
        }
    }

    if (queryBodyStyle) {
        const queryBodyStyleFilter = queryBodyStyle.split(',');

        filters.push({
            isEnabled: true,
            keyName: 'bodyStyle',
            keyValue: queryBodyStyleFilter,
            compareType: 'in',
        });
    }
    if (queryStatus) {
        if (!client) {
            filters.push({
                isEnabled: true,
                keyName: 'id',
                keyValue: queryStatus.toLowerCase(),
                fn: AvailableCheck,
                compareType: 'function',
            });
        } else {
            filters.push({
                isEnabled: true,
                keyName: 'id',
                keyValue: queryStatus.toLowerCase(),
                fn: AvailableCheckClient,
                compareType: 'function',
            });
        }
    }

    if (queryMake) {
        const makes = queryMake.split(',');
        if (makes.length > 0) {
            filters.push({
                isEnabled: true,
                keyName: 'make',
                keyValue: makes,
                compareType: 'in',
            });
        }
    }

    if (queryModel) {
        const models = queryModel.split(',');
        if (models.length > 0) {
            filters.push({
                isEnabled: true,
                keyName: 'model',
                keyValue: models,
                compareType: 'in',
            });
        }
    }

    return filters;
};

export const buildUrl = (filters: TFilterTerm<CarListingData>[]) => {
    const params = ['/buy-used-cars'];
    const filtersCanBeInParams = ['make', 'model'];
    const queryParams = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let q = 0; q < filters.length; q++) {
        const filter = filters[q];
        const keyName = paramAlias[filter.keyName]
            ? paramAlias[filter.keyName]
            : filter.keyName;

        if (filtersCanBeInParams.includes(filter.keyName)) {
            if (
                Array.isArray(filter.keyValue) &&
                filter.keyValue.length === 1
            ) {
                filter.keyValue = filter.keyValue as string[];
                params.push(filter.keyValue[0]);
            } else {
                queryParams.push(
                    `${keyName}=${(filter.keyValue as string[]).join(',')}`
                );
            }
        } else {
            if (
                typeof filter.keyValue === 'string' ||
                typeof filter.keyValue === 'number'
            ) {
                queryParams.push(`${keyName}=${filter.keyValue}`);
            } else {
                queryParams.push(
                    `${keyName}=${(filter.keyValue as string[]).join(',')}`
                );
            }
        }
    }
    const urlParts = [params.join('/')];
    if (queryParams.length > 0) {
        urlParts.push(queryParams.join('&'));
    }
    return urlParts.join('?');
};

const paramAlias: Record<string, string> = {
    sylndrSellingPrice: 'price',
    id: 'status',
    bodyStyle: 'bodystyle',
};

export const AvailableCheck = (
    item: CarListingData,
    availablity: comparableTypes
) => {
    let availableCheck = true;

    if (
        (availablity as CarStatus) === CarStatus.AVAILABLE &&
        (item.isReserved || item.isPurchaseInProgress)
    )
        availableCheck = false;

    if (
        (availablity as CarStatus) === CarStatus.RESERVED &&
        (item.isPurchaseInProgress || !item.isReserved)
    )
        availableCheck = false;

    if (
        (availablity as CarStatus) === CarStatus.BEING_SOLD &&
        !item.isPurchaseInProgress
    )
        availableCheck = false;
    return availableCheck;
};

export const GenerateComboList = (listings: CarListingData[] = []) => {
    const comboList: MakeModel = {};
    const bodyTypes: string[] = [];

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < listings.length; i++) {
        const make = listings[i].make.toLowerCase();
        const model = listings[i].model.toLowerCase();
        if (!bodyTypes.includes(listings[i].bodyStyle.toLowerCase())) {
            bodyTypes.push(listings[i].bodyStyle.toLowerCase());
        }

        if (comboList[make]) {
            if (!comboList[make].models.includes(model)) {
                comboList[make].models.push(model);
            }
        } else {
            comboList[make] = { models: [model], selected: false };
        }
    }
    return { comboList, bodyTypes };
};

const specialNames: Record<string, string> = {
    mini: 'MINI',
    mg: 'MG',
    bmw: 'BMW',
};

export const formatBrandName = (name: string) => {
    if (specialNames[name]) {
        return specialNames[name];
    } else {
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
};

export const formatYearForDisplay = (yearArr: number[] | string[]) => {
    if (!yearArr[1]) {
        return `${yearArr[0]}`;
    }

    if (yearArr[0] === yearArr[1]) {
        return `${yearArr[0]}`;
    }

    return `${yearArr[0]} - ${yearArr[1]}`;
};
export const formatPriceForDisplay = (
    priceArr: number[],
    lang: string,
    // eslint-disable-next-line @typescript-eslint/ban-types
    t: Function
) => {
    const from = priceArr[0] / 1000;
    const to = priceArr[1] / 1000;
    let toStr = `${to}K`;
    if (to >= 1000) toStr = `${to / 1000}M`;

    let fromStr = `${from}K`;
    if (from >= 1000) fromStr = `${from / 1000}M`;

    return lang === 'ar'
        ? `${toStr} - ${fromStr} ${t('EGP')}`
        : `${fromStr} - ${toStr} ${t('EGP')}`;
};
